export interface ThemeProps {
  mainThemeColor: string
  mainFontTheme?: string
}

export const defaultTheme: ThemeProps = {
  mainThemeColor: '#003471',
}

export const optumTheme: ThemeProps = {
  mainThemeColor: '#222222',
  mainFontTheme: 'Frutiger',
}

export const levelsTheme: ThemeProps = {
  mainThemeColor: '#5d7763',
  mainFontTheme: 'TT Hoves',
}

export const astellasTheme: ThemeProps = {
  mainThemeColor: '#ABE1FF',
  mainFontTheme: 'Avenir Next',
}

export const pfizerMerckTheme: ThemeProps = {
  mainThemeColor: '#034D83',
  mainFontTheme: 'Lato',
}

export const curativeTheme: ThemeProps = {
  mainThemeColor: '#074ADF',
  mainFontTheme: 'Soehne',
}
